// if (!customElements.get('zapiet-picker')) {
//   customElements.define(
//     'zapiet-picker',
//     class TermsConditions extends HTMLElement {
//       constructor() {
//         super();
//         const checkoutBtn = document.querySelector('#main-cart-footer #checkout');
//         checkoutBtn.dataset.awaitingCheckoutConditions = +checkoutBtn.dataset.awaitingCheckoutConditions || 0;
//         checkoutBtn.dataset.awaitingCheckoutConditions = +checkoutBtn.dataset.awaitingCheckoutConditions + 1;
//         checkoutBtn.disabled = true;

//         if(window.ZapietEvent) {
//           window.ZapietEvent.listen('checkoutEnabled', () => {
//             checkoutBtn.dataset.awaitingCheckoutConditions = +checkoutBtn.dataset.awaitingCheckoutConditions - 1;

//             if(+checkoutBtn.dataset.awaitingCheckoutConditions === 0) {
//               checkoutBtn.disabled = false;
//             }
//           });
//         }
//       }
//     }
//   );
// }



function updateCartCheckoutPrompt() {
  const checkoutBtn = document.querySelector('#main-cart-footer #checkout');
  const prompt = document.getElementById('cart-checkout-prompt');
  const promptText = document.getElementById('cart-checkout-prompt-text');
  
  if (!prompt || !checkoutBtn || !promptText) return;
  
  const zapietBlocked = checkoutBtn.dataset.zapietBlocked === 'true';
  const termsCheckbox = document.getElementById('terms_and_conditions');
  const termsBlocked = termsCheckbox && !termsCheckbox.checked;
  
  // Update button state
  checkoutBtn.disabled = zapietBlocked || termsBlocked;
  
  // Update prompt message
  if (zapietBlocked && termsBlocked) {
    promptText.textContent = promptText.getAttribute('data-delivery-text') || 
      "Para proceder, seleccione 'Entrega local' o 'Tienda de recogida' arriba.";
    prompt.hidden = false;
  } else if (zapietBlocked) {
    promptText.textContent = promptText.getAttribute('data-delivery-text') || 
      "Para proceder, seleccione 'Entrega local' o 'Tienda de recogida' arriba.";
    prompt.hidden = false;
  } else if (termsBlocked) {
    promptText.textContent = promptText.getAttribute('data-terms-text') || 
      "Para proceder, acepte los términos y condiciones.";
    prompt.hidden = false;
  } else {
    prompt.hidden = true;
  }
}

if (!customElements.get('zapiet-picker')) {
  customElements.define(
    'zapiet-picker',
    class ZapietPicker extends HTMLElement {
      constructor() {
        super();
        
        const checkoutBtn = document.querySelector('#main-cart-footer #checkout');
        if (!checkoutBtn) return;
        
        // Set Zapiet as initially blocked
        checkoutBtn.dataset.zapietBlocked = 'true';
        checkoutBtn.disabled = true;
        
        updateCartCheckoutPrompt();

        // Method 1: Using ZapietEvent (newer approach)
        if(window.ZapietEvent) {
          window.ZapietEvent.listen('checkoutEnabled', () => {
            checkoutBtn.dataset.zapietBlocked = 'false';
            updateCartCheckoutPrompt();
          });
        }
        
        // Method 2: Using IntegrationCheckoutClick callback
        const originalIntegrationClick = window.IntegrationCheckoutClick;
        window.IntegrationCheckoutClick = () => {
          // Check if Zapiet allows checkout
          if (typeof window.zapietValidation === 'function') {
            const isValid = window.zapietValidation();
            if (isValid) {
              checkoutBtn.dataset.zapietBlocked = 'false';
              updateCartCheckoutPrompt();
              
              // Proceed to checkout if all conditions met
              if (!checkoutBtn.disabled) {
                checkoutBtn.click();
              }
            }
          } else {
            // No validation function, assume Zapiet is ready
            checkoutBtn.dataset.zapietBlocked = 'false';
            updateCartCheckoutPrompt();
            
            if (!checkoutBtn.disabled) {
              checkoutBtn.click();
            }
          }
          
          // Call original if it existed
          if (originalIntegrationClick) {
            originalIntegrationClick();
          }
        };
      }
    }
  );
}


